import { ReactNode } from 'react';
import create from 'zustand';
import ExclamationFilledMark from '~components/Icon/ExclamationFilledMark';

import ExclamationMark from '~components/Icon/ExclamationMark';
import { generateUUID } from '~utils/common/uuid';

export type ToastVariant = 'default' | 'danger';

interface ToastOption {
  variant?: ToastVariant;
  duration?: number;
  icon?: ReactNode;
}

export type ToastContent = string;
export interface IToast {
  content: ToastContent;
  option: ToastOption;
  id: string;
}
interface ToastStore {
  toastList: Map<string, IToast>;
  toastShow: (content: ToastContent, option?: ToastOption) => void;
  toastClose: (toastId: string) => void;
  toastCloseAll: () => void;
}
export const useToastStore = create<ToastStore>((set, get) => ({
  toastList: new Map(),
  toastShow(content: ToastContent, option?: ToastOption) {
    const { toastList } = get();
    const toastId = generateUUID();
    const newToastList = new Map(toastList);
    const toastOption: ToastOption = { ...option, duration: option?.duration ?? 3500 };

    if (option?.variant === 'danger' && !option.icon) {
      toastOption.icon = <ExclamationFilledMark />;
    }

    newToastList.set(toastId, { id: toastId, content, option: toastOption });

    set({
      toastList: newToastList,
    });
  },
  toastClose(toastId: string) {
    const { toastList } = get();

    const newToastList = new Map(toastList);
    newToastList.delete(toastId);

    set({
      toastList: newToastList,
    });
  },
  toastCloseAll() {
    const newToastList = new Map();

    set({
      toastList: newToastList,
    });
  },
}));
